import { Badge } from "@/components/ui/badge"

export type AdminStatusTone =
  | "default"
  | "secondary"
  | "destructive"
  | "outline"
  | "info"
  | "success"
  | "warning"
  | "danger"
  | "neutral"
  | "purple"

interface AdminStatusBadgeProps {
  label: string
  tone?: AdminStatusTone
}

export function AdminStatusBadge({ label, tone = "neutral" }: AdminStatusBadgeProps) {
  return (
    <Badge variant={tone} className="rounded-full">
      {label}
    </Badge>
  )
}
